import HasID from './HasID'
import HasNames from './HasNames'
import HasAddress from './HasAddress'
import TrackedObject from './TrackedObject'
import HasLabel from './HasLabel';

export interface Person extends HasID, HasNames, HasAddress, TrackedObject {}

export class Person extends HasLabel {

    constructor(obj?:Person){
        super();

        this.address1 = '';
        this.address2 = '';
        this.addressCity = ''

        if(obj) Object.assign(this, obj);
    }

    toString(): string {
        let label = "";
        if(this.id && this.firstName && this.lastName){
            label = "ID: " + this.id + " " + this.displayNamesForPerson() + " Address: " + this.address1;
        }
        return label;
    }

    displayNamesForPerson(): string {
        if (!(this.id || this.lastName)) return "";
        return Person.concatName(this.firstName, this.lastName, this.middleName);
    }

    static concatName(firstName?:string, lastName?:string, middleName?:string, suffix?:string):string{
        let compiledName = "";
        compiledName += lastName
            ? lastName
            : "!! Unknown Lastname !!";
        compiledName += firstName ? ", " + firstName : "";
        compiledName += middleName ? " " + middleName : "";
        return compiledName;
    }

    // Joins only the parts actually on file, so a partial address renders without stray
    // separators — a record with a city but no street line used to emit a leading comma.
    get fullAddress(): string {
        const stateZip = Person.joinPresent(' ', this.addressState, this.addressZip);
        return Person.joinPresent(', ', this.address1, this.address2, this.addressCity, stateZip);
    }

    private static joinPresent(separator: string, ...parts: Array<string | undefined | null>): string {
        return parts
            .map(part => part?.trim())
            .filter((part): part is string => !!part)
            .join(separator);
    }
}
